<script lang="ts">
  import { shortDate } from '~/utils/dates';
  import { getSubscriptionQuery } from './mutations.svelte';
  import Premium from '~/icons/Premium.svelte';
  import Spinner from '~/components/Spinner.svelte';
  import StatusText from '~/components/StatusText.svelte';
  import { getTrialText } from './utils';

  const subscription = getSubscriptionQuery();
</script>

{#if subscription.isPending}
  <Spinner />
{:else if subscription.data}
  {@const sub = subscription.data}
  <!-- TODO this doesn't work when renewing a canceled sub -->
  {#if sub.status === 'trialing'}
    <div style:height="1em"></div>
    <StatusText status="warn">
      {getTrialText(sub)}
    </StatusText>
  {:else if sub.cancel_at}
    <div class="section">
      <div class="section-text">
        <h3>Premium Membership</h3>
        <span class="error">
          Ends on {shortDate(new Date(sub.cancel_at * 1000).toISOString())}
        </span>
      </div>
      <Premium size="3rem" />
    </div>
  {:else}
    <div class="section">
      <div class="section-text">
        <h3>Premium Membership</h3>
        Since {shortDate(new Date(sub.created * 1000).toISOString())}
      </div>
      <Premium size="3rem" />
    </div>
  {/if}
  {#if !sub.cancel_at}
    <div class="section">
      <div class="section-text">
        <span> Next Payment </span>
        <span class="secondary">
          {shortDate(new Date(sub.current_period_end * 1000).toISOString())}
        </span>
      </div>
      <span>
        ${((sub.items.data[0].price.unit_amount ?? 0) / 100).toFixed(2)} /
        {sub.items.data[0].price.recurring?.interval}
      </span>
    </div>
  {/if}
{:else}
  <div style:height="1em"></div>
  <StatusText status="success">
    You are a Premium member! If you would like to further support Gram Jam
    development, you can subscribe.
  </StatusText>
{/if}

<style lang="scss">
  @use '~/theme/themify' as *;
  .section {
    display: flex;
    justify-content: start;
    gap: 1rem;
    width: 100%;
    padding: 1em 0;
  }
  .section-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    * {
      margin: 0;
    }
  }
  .secondary {
    font-size: 0.8rem;
    opacity: 0.6;
  }
  .error {
    @include themify {
      color: themed('star-penalty');
    }
  }
</style>
